// plugins/growthbook.js
import Vue from 'vue'
import { GrowthBookVuePlugin } from '~/utils/growthbook/growthbook'

Vue.use(GrowthBookVuePlugin, {
  featuresEndpoint:
    'https://cdn.growthbook.io/api/features/sdk-wW6EqXlo115rdhd',
  enableDevMode: true,
})
